import { getCaptureMoves, getLegalMoves, getNormalMoves } from "../service/LegalMovesService";

export function getBestMove(pieces, blocks, playerType, depth = 3, captureOnly = false) {
  const currentPlayerPieces = pieces.filter(p => p.playerType === playerType);

  let bestScore = -Infinity;
  let bestMove = null;

  for (let piece of currentPlayerPieces) {
    const currentLegalMoves = getLegalMoves(piece.x, piece.y, pieces, blocks, captureOnly);

    if (currentLegalMoves?.length === 0) {

      continue;
    }

    for (let legalMove of currentLegalMoves) {

      const [newPieces, newBlocks] = movePiece(pieces, blocks, legalMove.x, legalMove.y, piece);

      const score = miniMax(newPieces, newBlocks, playerType === "black" ? "white" : "black", playerType, depth - 1, captureOnly);

      // We're maximizing for playerType
      if (score >= bestScore) {
        bestScore = score;
        bestMove = { piece, move: legalMove };
      }
    }
  }

  return bestMove;
}

function miniMax(pieces, blocks, turn, playerType, depth, captureOnly) {
  if (depth === 0) {
    return evaluateBoard(pieces, blocks, playerType, captureOnly);
  }

  const currentPlayerPieces = pieces.filter(p => p.playerType === turn);  // Fix: use 'turn'

  let bestScore = turn === playerType ? -Infinity : Infinity;

  for (let piece of currentPlayerPieces) {
    const currentLegalMoves = getLegalMoves(piece.x, piece.y, pieces, blocks, captureOnly);

    if (currentLegalMoves?.length === 0) {
      continue;
    }

    for (let legalMove of currentLegalMoves) {

      const [newPieces, newBlocks] = movePiece(pieces, blocks, legalMove.x, legalMove.y, piece);

      const score = miniMax(newPieces, newBlocks, turn === "black" ? "white" : "black", playerType, depth - 1, captureOnly);

      if (turn === playerType) {
        bestScore = Math.max(bestScore, score);
      } else {
        bestScore = Math.min(bestScore, score);
      }
    }
  }

  return bestScore;
}

function evaluateBoard(pieces, blocks, playerType, captureOnly) {
  let score = 0;

  const MAN_VALUE = 3;
  const KING_VALUE = 7;

  for (let piece of pieces) {
    const sign = piece.playerType === playerType ? 1 : -1;

    // Material
    score += sign * (piece.promoted ? KING_VALUE : MAN_VALUE);

    if (!captureOnly) {

      if (!piece.promoted) {
        // Legal moves
        const moves = getNormalMoves(piece.x, piece.y, pieces, blocks);
        score += sign * moves.length * 0.5;

        // Capture potential
        const captures = getCaptureMoves(piece.x, piece.y, pieces, blocks);
        score += sign * captures.length * 0.8;
      } else {
        const moves = getLegalMoves(piece.x, piece.y, pieces, blocks)
        score += sign * moves.length * 0.3;
      }
    } else {
      const captures = getLegalMoves(piece.x, piece.y, pieces, blocks, true);
      score += sign * captures.length * 0.8;
    }

    // Advancement toward promotion
    if (!piece.promoted) {
      const advance = piece.playerType === "black"
        ? piece.y
        : (7 - piece.y);

      score += sign * advance * 0.2;
    }

    // Center control
    const centerDist =
      Math.abs(piece.x - 3.5) + Math.abs(piece.y - 3.5);

    if (!piece.promoted) {
      score += sign * (3.5 - centerDist) * 0.1;
    }
  }

  return score;
}

function movePiece(pieces, blocks, x, y, paramSelectedPiece) {

  if (!paramSelectedPiece) {
    console.log('no selected piece');
    return [pieces, blocks];
  }

  // Move the piece
  let newPieces = pieces.map(p => {
    return p.id === paramSelectedPiece.id ? { ...p, x: x, y: y } : p;
  });
  newPieces = newPieces.filter(p => !p.captured);

  let capturedPiece = null;

  // Look up Direction Vector + stepping
  const dx = Math.sign(x - paramSelectedPiece.x);
  const dy = Math.sign(y - paramSelectedPiece.y);

  let oldX = paramSelectedPiece.x + dx;
  let oldY = paramSelectedPiece.y + dy;

  // Walk from initial position upto the current position
  while (oldX !== x || oldY !== y) {

    const currX = oldX;
    const currY = oldY;

    const piece = newPieces.find(p => p.x === currX && p.y === currY);

    if (piece) {
      newPieces = newPieces.map(p =>
        p.id === piece.id ? { ...p, captured: true } : p
      );
      capturedPiece = piece;
      break;
    }

    oldX += dx;
    oldY += dy;
  }

  if (!capturedPiece) {// End current's player turn if there's no capture happen

    return [newPieces, blocks]
  }
  newPieces = newPieces.filter(p => !p.captured);
  const newLegalCaptures = getLegalMoves(x, y, newPieces, blocks, true)

  if (newLegalCaptures.length > 0) {
    const updatedPiece = newPieces.find(p => p.id === paramSelectedPiece.id);
    return movePiece(newPieces, blocks, newLegalCaptures[0].x, newLegalCaptures[0].y, updatedPiece);
  }

  newPieces = newPieces.filter(p => !p.captured);
  return [newPieces, blocks]
}